import classNames from 'classnames';
import React, { Component } from 'react';

class AnnualCommitment extends Component {
  render() {
    const { availablePlan, annualPlan } = this.props;
    const className = classNames('activate-content__schedule-wrapper',
      {
        'activate-content__activate': availablePlan.id === annualPlan.id
      });
    return (
      <div onClick={() => this.props.onPlanSelect(annualPlan)} className="col px-0">
        <div className={className}>
          <div className="activate-content__commitment-period">
            <div className="activate-content__display-only-flex">
              <div>
                <p className="activate-content__shared-period-title">Annual</p>
              </div>
              {annualPlan.price.discountAsPercentage && (
              <div>
                <span className="activate-content__schedule-span-best">
                  {annualPlan.price.discountAsPercentage + '% off'}
                </span>
              </div>
              )}

            </div>
            <div className="period-select__sub-title">
              Billed monthly
            </div>
          </div>
          <div className="activate-content__schedule-hours align-items-end justify-content-center">
            <div className="period-select__title period-select__annual-commitment">
              <p className="activate-content__commitment-cost">{'$' + annualPlan.price.month }</p>
              <small>&nbsp;/mo</small>
            </div>
            <div>
              <p className="period-select__sub-title text-right">
                Paid in 12 installments
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AnnualCommitment;



// WEBPACK FOOTER //
// ./src/components/PlanSelect/AnnualCommitment/index.js